import type {
  PhoneSurveyConfigurationModelPhoneSurveyAnswerOptionConfigurationModel,
  PhoneSurveyConfigurationModelPhoneSurveyQuestionConfigurationModel,
  PhoneSurveyConfigurationModelVoiceMessageConfigurationParams,
} from '~/server_shared/openapi/data-contracts';

export const getEmptyQuestion = (): PhoneSurveyConfigurationModelPhoneSurveyQuestionConfigurationModel => ({
  question_configuration: emptyVoiceConfig(),
  answer_options: [
    {
      content_configuration: emptyVoiceConfig(),
      position: 1,
    },
  ],
});

export const getEmptyOption = (
  position: number
): PhoneSurveyConfigurationModelPhoneSurveyAnswerOptionConfigurationModel => ({
  content_configuration: emptyVoiceConfig(),
  position,
});

export const emptyVoiceConfig = (): PhoneSurveyConfigurationModelVoiceMessageConfigurationParams => ({
  configuration_type: 'text_message',
  message_text: '',
  stored_file_id: null,
});
